import { render } from "./TurnosPreferenciaModal.vue?vue&type=template&id=9c04dcce&scoped=true"
import script from "./TurnosPreferenciaModal.vue?vue&type=script&lang=js"
export * from "./TurnosPreferenciaModal.vue?vue&type=script&lang=js"

import "./TurnosPreferenciaModal.vue?vue&type=style&index=0&id=9c04dcce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c04dcce"]])

export default __exports__